"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var Geometry_1 = __importDefault(require("./Geometry"));
var GeometryCollectionBase = /** @class */ (function (_super) {
    __extends(GeometryCollectionBase, _super);
    function GeometryCollectionBase(geometries) {
        var _this = _super.call(this) || this;
        _this._geometries = new Array();
        if (!lodash_1.default.isUndefined(geometries)) {
            geometries.forEach(function (geom) { return _this._geometries.push(geom); });
        }
        return _this;
    }
    Object.defineProperty(GeometryCollectionBase.prototype, "children", {
        get: function () {
            return this._geometries;
        },
        enumerable: true,
        configurable: true
    });
    GeometryCollectionBase.prototype.coordinates = function () {
        return this.children.map(function (c) { return c.coordinates(); });
    };
    GeometryCollectionBase.prototype.coordinatesFlat = function () {
        var coordinates = lodash_1.default.flatMap(this._geometries, function (geom) { return geom.coordinatesFlat(); });
        return coordinates;
    };
    GeometryCollectionBase.prototype.forEachCoordinates = function (callback) {
        this._geometries.forEach(function (g) { return g.forEachCoordinates(callback); });
    };
    GeometryCollectionBase.prototype._cloneChildren = function (convert) {
        return this.children.map(function (c) { return c.clone(convert); });
    };
    return GeometryCollectionBase;
}(Geometry_1.default));
exports.default = GeometryCollectionBase;
